import { useState } from 'react'
import { useServiceWorker } from '@/utils/serviceWorker'
import { Button } from './Button'

export default function UpdateDebugPanel() {
  const [isOpen, setIsOpen] = useState(false)
  const { isUpdateAvailable, updateServiceWorker, resetUpdateState, clearCache, forceUpdate } = useServiceWorker()

  // Only show in development or if there are persistent update issues
  if (import.meta.env.PROD && !isUpdateAvailable) {
    return null
  }

  return (
    <>
      {/* Debug trigger - hidden by default */}
      <div 
        onClick={() => setIsOpen(true)}
        style={{
          position: 'fixed',
          bottom: '10px',
          right: '10px',
          width: '40px',
          height: '40px',
          backgroundColor: '#ef4444',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '20px',
          zIndex: 1000,
          opacity: 0.7
        }}
        title="App Update Debug"
      >
        🔄
      </div>

      {isOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '12px',
            maxWidth: '400px',
            width: '90%',
            maxHeight: '80vh',
            overflow: 'auto',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
          }}>
            <h2 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#1f2937' }}>
              🔄 App Update Debug Panel
            </h2>
            
            <div style={{ marginBottom: '16px', fontSize: '14px', color: '#6b7280' }}>
              <p><strong>Update Available:</strong> {isUpdateAvailable ? 'Yes' : 'No'}</p>
              <p><strong>Environment:</strong> {import.meta.env.MODE}</p>
              <p><strong>Service Worker:</strong> {'serviceWorker' in navigator ? 'Supported' : 'Not Supported'}</p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
              <Button
                onClick={() => {
                  updateServiceWorker()
                  setIsOpen(false)
                }}
                className="w-full"
                disabled={!isUpdateAvailable}
              >
                🔄 Apply Update
              </Button>

              <Button
                onClick={() => {
                  resetUpdateState()
                  setIsOpen(false)
                }}
                variant="secondary"
                className="w-full"
              >
                ❌ Reset Update State
              </Button>

              <Button
                onClick={async () => {
                  await clearCache()
                  alert('Cache cleared! Refresh the page.')
                }}
                variant="secondary"
                className="w-full"
              >
                🗑️ Clear Cache
              </Button>

              <Button
                onClick={async () => {
                  if (confirm('This will clear all data and reload the app. Continue?')) {
                    await forceUpdate()
                  }
                }}
                variant="danger"
                className="w-full"
              >
                ⚡ Force Update
              </Button>
            </div>

            <div style={{ fontSize: '12px', color: '#9ca3af', marginBottom: '16px' }}>
              <p><strong>What do these do?</strong></p>
              <ul style={{ margin: '4px 0', paddingLeft: '16px' }}>
                <li><strong>Apply Update:</strong> Activates pending update</li>
                <li><strong>Reset Update State:</strong> Dismisses update notification</li>
                <li><strong>Clear Cache:</strong> Removes cached files</li>
                <li><strong>Force Update:</strong> Nuclear option - clears everything</li>
              </ul>
            </div>

            <Button
              onClick={() => setIsOpen(false)}
              variant="secondary"
              className="w-full"
            >
              Close
            </Button>
          </div>
        </div>
      )}
    </>
  )
}